module.exports = __webpack_public_path__ + "img/chinesecompany200.da253a1d.png";